import { Box } from '@chakra-ui/react'
import { Button } from 'uikit'
import { Field, Formik } from 'formik'
import moment from 'moment'
import { useCallback } from 'react'
import { InputDateForm } from 'uikit/FormStateComponents/InputDateForm'
import { Form } from 'uikit/layout'
import * as Yup from 'yup'
import { useSendParityRegistry } from '../hooks/useSendParityRegistry'

export const validationSchema = Yup.object().shape({
  date: Yup.string().required('Обязательное поле'),
})

export const RbForm = () => {
  const { mutate: sendRegistry, isLoading } = useSendParityRegistry()

  const onSubmitHandle = useCallback((values) => {
    sendRegistry(values)
  }, [])

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      onSubmit={onSubmitHandle}
      validationSchema={validationSchema}
      validateOnMount
    >
      {(props) => (
        <Form>
          <Field
            disabled={isLoading}
            name="date"
            label="Дата"
            placeholder="Выберите дату"
            component={InputDateForm}
            autoComplete="off"
            withDialog
            dayPickerProps={{
              disabledDays: {
                after: moment().add(-1, 'd').toDate(),
              },
            }}
          />

          <Box pt="40px">
            <Button
              disabled={!props.isValid}
              onClick={props.handleSubmit}
              colorPalette="orange"
              loading={isLoading}
            >
              Отправить РБ реестры
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  )
}
